import "./DiscussionExchangesContainer.scss";

export default {
  root: "im-discussion-exchanges-container",
  exchangesList: "im-discussion-exchanges-container__exchanges-list",
  formContainer: "im-discussion-exchanges-container__form-container",
};
